import {
  EditOutlinedIcon,
  DeleteOutlinedIcon,
} from '../customStyles/images';

export const ICON_LIST = {
  EditOutlinedIcon,
  DeleteOutlinedIcon,
}